import React from 'react';
import { useResponsive, useTranslation } from 'client/hooks';
import { ControlPanel, Header } from 'client/components/common/mobile';
import { HelmetComponent } from 'client/components/common';
import { staticPages as staticPagesApi } from 'client/redux/api/static-pages';
import { TARGET_VALUES } from 'models/other/interface';
import css from './AccessibilityStatement.module.scss';
import rtCSS from 'src/routes/client/styles/RichTextContent.module.scss';

const AccessibilityStatement = () => {
  const [isMobile] = useResponsive(['MOBILE']);
  const { translate } = useTranslation();
  const { data, isFetching } = staticPagesApi.endpoints.getStaticPage.useQuery({
    target: TARGET_VALUES.ACCESSIBILITY_STATEMENT,
  });
  const pageData = data?.success && data.data ? data.data : { title: '', body: '' };

  return (
    <>
      <HelmetComponent
        title={translate('seo.accessibilityStatement.title')}
        description={translate('seo.accessibilityStatement.description')}
        ogTitle={translate('seo.accessibilityStatement.title')}
        ogDescription={translate('seo.accessibilityStatement.description')}
      ></HelmetComponent>
      <div className={css.pageWrapper}>
        {isMobile ? <Header className={css.pageHeader} /> : null}
        {isMobile ? <ControlPanel className={css.controlPanel} /> : null}

        {pageData && (
          <div className={css.contentWrapper}>
            <div className={rtCSS.title}>{pageData?.title}</div>
            <div className={rtCSS.richTextContent} dangerouslySetInnerHTML={{ __html: pageData.body }}></div>
          </div>
        )}
      </div>
    </>
  );
};

export default AccessibilityStatement;
